"use strict";

exports.__esModule = true;
exports.Drawer = Drawer;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _reactTransitionGroup = require("react-transition-group");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["isOpen", "position", "onClose"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var TransitionContainer = _styledComponents["default"].div.withConfig({
  displayName: "Drawer__TransitionContainer",
  componentId: "sc-q1gh60-0"
})(["position:relative;"]);
var DrawerContainer = _styledComponents["default"].aside.withConfig({
  displayName: "Drawer__DrawerContainer",
  componentId: "sc-q1gh60-1"
})(["background:white;padding:5px;position:absolute;transition:height 0.2s linear;&.drawer-top{display:flex;overflow-y:auto;max-height:50vh;flex:1;width:100vw;left:0;right:0;transition:top 100ms linear;}&.drawer-top.drawer-top-enter,&.drawer-top.drawer-top-appear{top:-50vh;}&.drawer-top.drawer-top-enter-done,&.drawer-top.drawer-top-appear-done{top:0;}&.drawer-bottom{display:flex;flex:1;width:100vw;overflow-y:auto;height:400px;left:0;right:0;transition:top 100ms linear;}&.drawer-bottom.drawer-bottom-enter,&.drawer-bottom.drawer-bottom-appear{top:150vh;}&.drawer-bottom.drawer-bottom-enter-done,&.drawer-bottom.drawer-bottom-appear-done{top:calc(100vh - 400px);}&.drawer-left{display:flex;flex:1;overflow-y:auto;max-width:50vw;height:100vh;top:0;bottom:0;transition:left 100ms linear;}&.drawer-left.drawer-left-enter,&.drawer-left.drawer-left-appear{left:-50vw;}&.drawer-left.drawer-left-enter-done,&.drawer-left.drawer-left-appear-done{left:0;}&.drawer-right{display:flex;flex:1;overflow-y:auto;max-width:50vw;height:100vh;top:0;bottom:0;transition:right 100ms linear;}&.drawer-right.drawer-right-enter,&.drawer-right.drawer-right-appear{right:-50vw;}&.drawer-right.drawer-right-enter-done,&.drawer-right.drawer-right-appear-done{right:0;}"]);

/**
 * Displays content in a drawer which slides out from the top, bottom,
 * left or right edge of the screen.
 */
function Drawer(_ref) {
  var isOpen = _ref.isOpen,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? "right" : _ref$position,
    onClose = _ref.onClose,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  var body = /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.TransitionGroup, {
    appear: true,
    component: TransitionContainer
  }, [/*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    key: "content",
    "in": isOpen,
    timeout: 100,
    classNames: "drawer-" + position
  }, /*#__PURE__*/_react["default"].createElement(DrawerContainer, _extends({
    className: "drawer-" + position
  }, extra)))]);
  return /*#__PURE__*/_react["default"].createElement(_core.Overlay, {
    isOpen: isOpen,
    onClose: onClose
  }, body);
}